import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { toggle } from "@saleor/utils/lists";
import classNames from "classnames";
import React from "react";

import Checkbox from "../Checkbox";
import { FilterBaseFieldProps } from "./types";

const useStyles = makeStyles(
  theme => ({
    option: {
      left: -theme.spacing(0.5),
      position: "relative"
    },
    optionRadio: {
      left: -theme.spacing(0.25)
    },
    root: {}
  }),
  { name: "FilterOptionField" }
);

const FilterOptionField: React.FC<FilterBaseFieldProps> = ({
  filterField,
  onFilterPropertyChange,
  ...rest
}) => {
  const classes = useStyles({});
  const handleSelect = (value: string) =>
    onFilterPropertyChange({
      payload: {
        name: filterField.name,
        update: {
          value: filterField.multiple
            ? toggle(value, filterField.value, (a, b) => a === b)
            : [value]
        }
      },
      type: "set-property"
    });

  const filterOptionId = option =>
    option
      .toString()
      .replace(/[_\s.:][a-z]/g, letter => letter[1].toUpperCase())
      .replace(/[_\s.:]/g, "")
      .replace(/^./, letter => letter.toUpperCase())
      .toLowerCase();

  return (
    <div className={classes.root} {...rest}>
      {filterField.options.map(option => (
        <div
          className={classNames(classes.option, {
            [classes.optionRadio]: !filterField.multiple
          })}
          key={option.value}
          id={`filterOption${filterOptionId(option.value)}`}
        >
          <FormControlLabel
            control={
              filterField.multiple ? (
                <Checkbox
                  id={`filterOptionCheckbox${filterOptionId(option.value)}`}
                  data-test="filterOption"
                  data-test-id={option.value}
                  checked={filterField.value.includes(option.value)}
                />
              ) : (
                <Radio
                  id={`filterOptionRadioButton${filterOptionId(option.value)}`}
                  data-test="filterOption"
                  data-test-id={option.value}
                  checked={filterField.value[0] === option.value}
                  color="primary"
                />
              )
            }
            label={option.label}
            name={filterField.name}
            onChange={() => handleSelect(option.value)}
          />
        </div>
      ))}
    </div>
  );
};

FilterOptionField.displayName = "FilterOptionField";
export default FilterOptionField;
